export function dataInRequest(params = {}) {
    return {
        type: '@equipamento/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@equipamento/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@equipamento/FAILED_REQUEST',
    };
}

export function deleteData(id, params) {
    return {
        type: '@equipamento/DELETE_DATA',
        payload: { id, params },
    };
}

export function updateData(data, params) {
    return {
        type: '@equipamento/UPDATE_DATA',
        payload: { data, params },
    };
}

export function updateVazao(data, params) {
    return {
        type: '@equipamento/UPDATE_VAZAO',
        payload: { data, params },
    };
}

export function updateEletronica(data, params) {
    return {
        type: '@equipamento/UPDATE_ELETRONICA',
        payload: { data, params },
    };
}

export function storeData(data, params) {
    return {
        type: '@equipamento/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@equipamento/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@equipamento/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@equipamento/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@equipamento/RECORD_FILTERING',
        payload: { params },
    };
}
